import ecologyGirlPicture from "images/le-club/ecology/girl.webp";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";

import { Button } from "ui/Button";
import { StaticImage } from "ui/StaticImage";
import { useGetLottieScrollPosition } from "utils/useGetLottieScrollPosition";
import { useI18n } from "utils/with-i18n.utils";

import Leaf from "./leaf.svg";
import LeafMobile from "./leafMobile.svg";
import planeAnimation from "./plane.json";

const Lottie = dynamic(() => import("react-lottie-player"));

export const Ecology = () => {
  const i18n = useI18n();
  const { push } = useRouter();
  const { animationContainerRef, animationStartFrame } =
    useGetLottieScrollPosition<HTMLDivElement>();

  const handleGoToCatalog = () => push("/smartphone");

  return (
    <section className="flex flex-col-reverse lg:flex-row">
      <div className="aspect-square flex relative basis-1/2 justify-center lg:aspect-auto">
        <StaticImage
          src={ecologyGirlPicture}
          alt="decoration ecology girl image"
          layout="fill"
          width={1512}
          height={1328}
          objectFit="cover"
          placeholder="blur"
        />
        <Button
          className="self-end mb-10 lg:hidden"
          onClick={handleGoToCatalog}
        >
          {i18n.t("club.cta")}
        </Button>
      </div>
      <div className="flex basis-1/2 flex-col items-center">
        <p className="py-0 mt-14 mb-3 lg:py-4 lg:mb-0 lg:text-lg">
          {i18n.t("club.ecology.start")}
        </p>
        <div className="px-0 lg:px-12">
          <div className="flex relative py-0 px-4 lg:py-1">
            <div className="flex relative z-10 flex-nowrap w-max">
              <span
                className="relative text-[45px] font-black text-white lg:hidden "
                style={{
                  WebkitTextStroke: "0.5px black",
                  textShadow: `
          0.5px 0.5px 0 #000,
          1px 1px 0 #000,
          0.75px 0.75px 0 #000,
          2px 2px 0 #000,
          1px 1px 0 #000,
          2px 2px 0 #000,
          1.5px 1.5px 0 #000
          `,
                }}
              >
                {i18n.t("club.ecology.co2.number")}
                <LeafMobile className="absolute top-2 -right-3 z-[-1] xl:top-0" />
              </span>
              <span
                className="hidden relative max-w-max text-[50px] font-black text-white lg:block xl:text-7xl"
                style={{
                  WebkitTextStroke: "1px black",
                  textShadow: `
          0.5px 0.5px 0 #000,
          1px 1px 0 #000,
          0.75px 0.75px 0 #000,
          2px 2px 0 #000,
          2.5px 2.5px 0 #000,
          5px 5px 0 #000,
          2px 2px 0 #000
        `,
                }}
              >
                {i18n.t("club.ecology.co2.number")}
                <Leaf className="absolute top-0.5 -right-5 z-[-1] xl:-top-1" />
              </span>
            </div>
          </div>
        </div>
        <p className="py-0 mb-12 text-2xl lg:py-3 lg:mb-14 lg:text-4xl">
          {i18n.t("club.ecology.co2")}
        </p>
        <div
          ref={animationContainerRef}
          className="ml-4 w-3/4 lg:ml-12 lg:w-2/3"
        >
          <Lottie animationData={planeAnimation} goTo={animationStartFrame} />
        </div>
        <p className="my-7 lg:mt-5 lg:mb-10">
          {i18n.t("club.ecology.flight1")}
          <span className="font-semibold">
            {i18n.t("club.ecology.flight2")}
          </span>
          {i18n.t("club.ecology.flight3")}
        </p>

        <Button
          className="mb-20"
          alternative="tertiary"
          onClick={() => push("/ecologie-location-telephone")}
        >
          {i18n.t("club.ecology.knowMore")}
        </Button>
      </div>
    </section>
  );
};
